{
  "method": "docs/plans/houses.md, section 8.4: block sides inside the georeference's hull, facing the viewer within 45 degrees and at least twice the georeference error long, read by eye where one row lies on the model's front line",
  "scan": "docs/reference/woodcut-1544-uva-8000px.jpg, 3840 x 3723 px, crops at 4x in $S/houses/woodcut/facecrops",
  "sides": {
    "street-kalverstraat-2:left:0": {
      "frontage": 126.9,
      "fronts": 17,
      "stepped": 8,
      "note": "One row of fronts facing the viewer between the block's ends."
    },
    "quay-rokin-southwest:left:0": {
      "frontage": 195,
      "fronts": 18,
      "stepped": 1,
      "note": "The Rokin's west bank, the one row there facing the viewer; the model's front line lies in the water, 22 m off. Fences over about 36 m."
    },
    "lastage-sint-antoniesbreestraat:right:0": {
      "frontage": 209.3,
      "fronts": 12,
      "stepped": 0,
      "note": "Houses in groups along the dike road, between palisades and orchards. Reprojected onto the same physical western bank after the 2026-10-03 Waag approach correction reversed and extended the street centreline: formerly left:1, with 151.6 m of frontage. The original twelve fronts and zero stepped gables are retained; the longer current block also includes the approach toward the Waag."
    },
    "lastage-sint-antoniesbreestraat:right:1": {
      "frontage": 88.1,
      "fronts": 1,
      "stepped": null,
      "note": "Open ground, at most one building. Reprojected onto the same physical western bank at the outer dike crossing after the 2026-10-03 street reversal: formerly left:0, with 81.4 m of frontage. The original one-front estimate is retained."
    },
    "lastage-nieuwe-hoogstraat:left:0": {
      "frontage": 97,
      "fronts": 4,
      "stepped": null,
      "note": "Fields with about four houses."
    },
    "lastage-oudeschans-4:left:0": {
      "frontage": 85.7,
      "fronts": 1,
      "stepped": null,
      "note": "One house and long sheds."
    },
    "lastage-recht-boomssloot-2:right:1": {
      "frontage": 119.1,
      "fronts": 0,
      "stepped": null,
      "note": "Open ground."
    },
    "lastage-recht-boomssloot-3:right:0": {
      "frontage": 116.4,
      "fronts": 1,
      "stepped": null,
      "note": "Open ground, at most one building."
    },
    "street-koestraat:left:0": {
      "frontage": 69.1,
      "fronts": 3,
      "stepped": null,
      "note": "Three houses over lots 1-5; the church labelled 'Betanien' over lots 6-12."
    },
    "street-molensteeg:left:0": {
      "frontage": 33.61,
      "fronts": 3,
      "stepped": null,
      "note": "Three or four exposed small fronts beside the long convent range labelled Selle Susters. The first four generated front positions remain on the same street stretch after removing Hoogkamersgang; the later generated frontage is shorter, so its frontage lock is refreshed. The institutional range still needs its own component reconstruction."
    }
  },
  "unread": {
    "street-kalverstraat-2:left:1": "Two rows of fronts facing the viewer lie within the georeference error (23 m) of the front line.",
    "shore:316.4,552.9:right:0": "The front line falls in the IJ, 38 m off; the quay rows above it cannot be told apart.",
    "street-nieuwendijk:left:5": "The side bends: lots 1-13 face away from the viewer, lots 14-22 lie under the row of the Sint Jacobskapel.",
    "street-elleboogsteeg:right:0": "The front line crosses a yard and the side walls of two rows.",
    "street-halsteeg:left:0": "The front line crosses the rows; the georeference error is 30 m.",
    "street-nes:right:3": "Two rows of fronts lie within the georeference error (28 m).",
    "street-oudekerksplein:left:0": "The lots fall on the Oude Kerk's chapels and on two rows.",
    "street-oudezijds-armsteeg:left:0": "The front line crosses the rows.",
    "street-pijlsteeg:left:0": "Two rows lie within the georeference error (30 m).",
    "street-sint-jansstraat:left:0": "The front line runs between two rows, within the georeference error (22 m).",
    "street-wijngaardsstraatje:left:0": "The front line crosses the rows.",
    "street-prinsenhofssteeg:left:0": "The remaining two procedural fronts occupy only an approximately 10.82 m fragment on the northern residential side. The former zero-front convent reading belongs to the south-side Cecilia compound, now modelled separately; it does not count these houses.",
    "street-zeedijk:left:1": "The remaining side pools two fronts toward Boomsteeg with the distant northern Zeedijk row near layout [568,250]–[543,290]. The local four-front/two-stepped evidence is preserved under retired street-zeedijk:left:1; it does not count this entire pooled frontage. Individual properties still need to be recorded. After the Paulus precinct removes southern Achterburgwal fronts, the long quay source re-plans adjacent lots and this pooled Zeedijk frontage loses its generated Boomsteeg cross-way cut. Its label is now left:1; the approximately 55.49 m total frontage still combines separate residential stretches. The former four-front/two-stepped count is not applied to it."
  },
  "groups": {
    "lastage-keizersstraat-gardens": {
      "fronts": 5,
      "stepped": null,
      "note": "Fields and fenced yards with about five houses. Read as lastage-keizersstraat:left:0 (117.2 m of frontage) until the layout dropped the Keizersstraat (2026-09-28): the houses stand in a row by the Sint Antoniespoort among garden plots, tenter frames and sheds, on no street (src/world/fabric/lastageGardenHouses.ts)."
    },
    "surveyed-lange-niezel-south": {
      "frontage": 58.8,
      "fronts": 11,
      "stepped": 0,
      "note": "The gable ends of one row along the front line; the fronts are seen at a grazing angle. The original eleven fronts and zero stepped gables are now retained as individual lange-niezel-south entries in surveyed/oudezijdeRows.json (2026-10-03). The old procedural block key no longer addresses these plots; their widths/depths are estimated within the explicit block."
    }
  },
  "retired": {
    "street-nieuwebrugsteeg:right:0": "The former procedural side fell on two rows in the woodcut. The straight Damrak bank and explicit Nieuwe Brug frontage replace that generated side; its uncertain note is preserved here without applying it to another block.",
    "street-heintje-hoekssteeg:left:0": "The front line crosses the rows; the alley is not drawn. Procedural fronts removed by the explicit two-block reconstruction; the open woodcut yard is preserved and this uncertain crossing is not reinterpreted as another row.",
    "street-zeedijk:left:1": "The former 51.8 m reading counted four fronts and two stepped gables on only the northern row near layout [568,250]–[543,290], excluding a distant first lot. Convent reservations change generated cross-way cuts and pool this row with other residential frontage. The numerical left:1 label is reused by the current approximately 55.49 m pooled block after the Paulus refinement, but its historical four-front count does not describe that composite block. Preserve the local evidence without imposing that count on it; individual northern properties remain to be recorded.",
    "street-prinsenhofssteeg:right:0": "Former 40.4 m side, zero domestic fronts: the reading identified convent buildings, a court and chapel. The corrected Cecilia reservation south of Prinsenhofsteeg now replaces that procedural side with separate institutional components. This evidence is retained here, not transferred to the restored northern residential frontage.",
    "quay-oudezijds-voorburgwal:left:1": "The canal bank runs past the convents labelled 'Anghenieten' and 'S. Barbaren'; which buildings stand on the model's lots is not clear. The former generated side had ten fronts near layout [104,-354]–[114,-302]. The separate Barbara reservation and Magdalena private approach remove those procedural plots (2026-10-04); the key no longer exists. This unresolved source note is retained here, without applying a domestic house count to the institutional components or transferring it to another canal block."
  }
}
